import { LoadingCapabilitiesAvailability } from "@freightsimple/generated-dashboard-openapi-client/models/LoadingCapabilitiesAvailability";
import {
  Dropdown,
  type DropdownOption,
} from "@freightsimple/ui-core/Controls/Dropdown";
import {
  FormItem,
  type ErrorMessageType,
} from "@freightsimple/ui-core/FormLayout/FormItem";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import React from "react";

interface LoadingCapabilitiesDropdownProps {
  question: string;
  value: LoadingCapabilitiesAvailability;
  onChange: (value: LoadingCapabilitiesAvailability) => void;
  errorMessage?: ErrorMessageType | undefined;
  forceValidation?: boolean | undefined;
  "data-testid"?: string | undefined;
}

const LoadingCapabilitiesDropdown: React.FC<
  LoadingCapabilitiesDropdownProps
> = ({
  question,
  value,
  onChange,
  errorMessage,
  forceValidation,
  "data-testid": dataTestId,
}) => {
  const options: Array<DropdownOption> = [
    {
      value: LoadingCapabilitiesAvailability.Yes,
      label: "Yes",
    },
    {
      value: LoadingCapabilitiesAvailability.No,
      label: "No",
    },
  ];

  return (
    // The question is the field's label, styled like every other field label
    // ("Open From", ...). Vertical spacing between stacked questions belongs
    // to the caller (a Stack gap), not a margin here.
    <ShowFormErrors show={forceValidation ?? false}>
      <FormItem label={question} error={errorMessage} fillWidth>
        <Dropdown
          value={
            value === LoadingCapabilitiesAvailability.Unknown
              ? undefined
              : value
          }
          onChange={(v) => onChange(v as LoadingCapabilitiesAvailability)}
          options={options}
          placeholder="Select your answer"
          width="full"
          data-testid={dataTestId ?? "loading-capabilities-dropdown"}
        />
      </FormItem>
    </ShowFormErrors>
  );
};

export default LoadingCapabilitiesDropdown;
